import type { FlatRow } from './types';

export function getProductRowClassName(row: FlatRow): string {
  const classes: string[] = [];
  
  const periodIsNew = (row.period as any).isNew === true;
  const bandIsNew = (row.band as any).isNew === true;
  
  if (periodIsNew || bandIsNew) classes.push('new-row');
  if ((row.product as any).hasPendingChanges) classes.push('locked');
  if ((row.product as any).isUpdated && !(row.product as any).isNew) classes.push('updated');
  if ((row.product as any).decommissionDate) classes.push('decommissioned');
  
  return classes.join(' ');
}

